import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SmokeFreeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"smoke_free"}/>
}
